/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, convertHexToRGB } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED CONTROLLER CONTAINER : STYLES --------------- ++++++++++ */
export default theme => ({
	controllercontainer: {
		borderRadius: pxToEm(5),
		border: replacePXinStringWithEM(`1px solid #ECF0F7`),
		boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
		padding: pxToEm(8),
		transition: 'all .2s linear 0s',
		'& .title': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			marginBottom: pxToEm(8),
			'& h4': {
				fontSize: pxToEm(12),
				fontWeight: 'bold',
				marginBottom: '0',
				'& span': {
					color: convertHexToRGB(theme.color.supporting.medium.swatch, 50)
				}
			},
			'& h4.no-bold': {
				fontWeight: '500'
			}
		},
		'&:hover': {
			boxShadow: theme.boxShadow.highlightCard
		}
	}
});
